import { render, staticRenderFns } from "./ObjectivesModal.vue?vue&type=template&id=04af60a1&scoped=true&"
import script from "./ObjectivesModal.vue?vue&type=script&lang=js&"
export * from "./ObjectivesModal.vue?vue&type=script&lang=js&"
import style0 from "./ObjectivesModal.vue?vue&type=style&index=0&id=04af60a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04af60a1",
  null
  
)

export default component.exports